export type TrackingCheck = {
  status: "pass" | "issue" | "unknown";
  label: string;
  detail: string;
};
export type PublicationTracking = {
  version: 1;
  url: string;
  state: "running" | "checked";
  startedAt: string;
  checkedAt: string | null;
  token?: string;
  publication?: TrackingCheck;
  indexability?: TrackingCheck;
  sitemap?: TrackingCheck;
  internalLink?: TrackingCheck;
  search?: TrackingCheck;
};
export function parsePublicationTracking(
  raw?: string | null
): PublicationTracking | null {
  try {
    const value = JSON.parse(raw || "null");
    if (
      !value ||
      value.version !== 1 ||
      typeof value.url !== "string" ||
      !["running", "checked"].includes(value.state) ||
      !Number.isFinite(Date.parse(value.startedAt))
    )
      return null;
    if (
      value.checkedAt !== null &&
      !Number.isFinite(Date.parse(value.checkedAt))
    )
      return null;
    for (const key of [
      "publication",
      "indexability",
      "sitemap",
      "internalLink",
      "search",
    ]) {
      const check = value[key];
      if (value.state === "checked" && !check) return null;
      if (
        check &&
        (!["pass", "issue", "unknown"].includes(check.status) ||
          typeof check.label !== "string" ||
          typeof check.detail !== "string")
      )
        return null;
    }
    return value;
  } catch {
    return null;
  }
}
export function trackingIsDue(
  raw: string | null | undefined,
  url: string,
  now = Date.now()
) {
  const value = parsePublicationTracking(raw);
  if (!value || value.url !== url) return true;
  if (value.state === "running")
    return now - Date.parse(value.startedAt) >= 10 * 60_000;
  return (
    !value.checkedAt || now - Date.parse(value.checkedAt) >= 24 * 60 * 60_000
  );
}
